var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08334 15.5422L4.7848 10.9444L0.187012 8.64583L4.7848 6.34729L7.08334 1.7495L9.38189 6.34729L13.9797 8.64583L9.38189 10.9444L7.08334 15.5422ZM12.75 15.375L13.8125 17.5L14.875 15.375L17 14.3125L14.875 13.25L13.8125 11.125L12.75 13.25L10.625 14.3125L12.75 15.375ZM13.6942 3.80579L14.5208 5.45833L15.3475 3.80579L17 2.97917L15.3475 2.15254L14.5208 0.5L13.6942 2.15254L12.0417 2.97917L13.6942 3.80579Z",
    fill: "url(#paint0_linear_821_837)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_821_837",
    x1: 8.59351,
    y1: 0.5,
    x2: 8.59351,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40C7C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#198282"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/Sparkles.3cb183c9a2849668ac4ad529618cdee3.svg";
export { ForwardRef as ReactComponent };